// Storage item namespace prefixes.
export const APP_STORAGE_NAMESPACE = "Emory.commerce";
export const CART_STORAGE_NAMESPACE = "Emory.commerce.cart";
export const ORDER_STORAGE_NAMESPACE = "Emory.commerce.order";
export const CHECKOUT_STORAGE_NAMESPACE = "Emory.commerce.checkout";

// Storage item keys.
export const COMMERCE_APP_RELEASE = "Emory.commerce.release";
export const COMMERCE_CART_TOKEN = "Emory.commerce.cart.token";
export const COMMERCE_CART_ITEMCOUNT = "Emory.commerce.cart.itemCount";
export const COMMERCE_ORDER_APPEALCODE = "Emory.commerce.order.appealCode";
export const COMMERCE_CHECKOUT_DETAILS = "Emory.commerce.checkout.details";
export const COMMERCE_CHECKOUT_ENABLE_APPLEPAY =
  "Emory.commerce.checkout.enableApplePay";
export const COMMERCE_CHECKOUT_OPTION_PRESETS_HONOREE =
  "Emory.commerce.checkout.optionPresets.honoree";
export const COMMERCE_CHECKOUT_OPTION_PRESETS_PLEDGE =
  "Emory.commerce.checkout.optionPresets.pledge";
export const COMMERCE_CHECKOUT_OPTION_PRESETS_JOINT_GIFT =
  "Emory.commerce.checkout.optionPresets.jointGift";
export const COMMERCE_CAMPAIGN_PATH = "Emory.commerce.campaign.path";
export const COMMERCE_CAMPAIGN_FUND = "Emory.commerce.campaign.fundSelected";
export const COMMERCE_WEBFORM_ID = "Emory.commerce.webform.id";
export const COMMERCE_WEBFORM_PATH = "Emory.commerce.webform.path";
export const COMMERCE_WEBFORM_TOKEN = "Emory.commerce.webform.token";
export const COMMERCE_WEBFORM_SUBMISSION = "Emory.commerce.webform.submission";
export const COMMERCE_WEBFORM_CONFIRMATION =
  "Emory.commerce.webform.confirmation";
